// Module
var code = `<div class="js-numeric-container {{.additionalClass}} {{#if .enabled}}{{#.hasError}}js-input-container-error{{/}}{{/if}}{{#if isPosAbsolute}} absolute{{/if}}"
     {{^.visible}}style-display="none" {{/}}
     on-mousedown="@this.onMouseDown(event)"
     {{#if isPosAbsolute}}style="{{>position}}"{{/if}}
     {{>visualparameters}}>

    <input tabindex="{{enabled ? 0 : -1}}"
           {{#if !enabled && !enableOnSelect}}disabled{{/if}}
           name="{{name}}"
           type="text"
           class-js-input-numeric="1"
           class-js-input-numeric-noArrows={{!showArrows}}
           on-keypress="@this.private_KeyPress(this, event.original)"
           on-keydown="keyDown"
           on-keyup="keyUp"
           on-focus="focus"
           on-blur="@this.lostFocus()"
           on-wheel="mousewheel"
           on-mousewheel="mousewheel"
           as-tooltip="tooltip"
           value="{{formattedValue}}"
           class="{{customCSSClass ? customCSSClass : ''}}"
           autocomplete="off" />
    <div class="js-numeric-right-text{{rightAlignedTextAdditionalClass ? ' ' + rightAlignedTextAdditionalClass : ''}}" style-display="{{rightAlignedText ? 'flex' : 'none'}}">{{rightAlignedText}}</div>
    <div class="js-numeric-arrow" style-display="{{enabled && showArrows ? 'flex' : 'none'}}">
        <div class="js-numeric-arrow-up"
             on-mousedown="@this.arrowMouseDownWrapper(event, true)"
             on-mouseup="@this.private_arrowMouseup(this, true)"
             on-mouseout="@this.private_arrowMouseout(this, true)">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#numeric_arrow_up"></use>
            </svg>
        </div>

        <div class="js-numeric-arrow-down"
             on-mousedown="@this.arrowMouseDownWrapper(event, false)"
             on-mouseup="@this.private_arrowMouseup(this, false)"
             on-mouseout="@this.private_arrowMouseout(this, false)">
            <svg>
                <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#numeric_arrow_down"></use>
            </svg>
        </div>
    </div>
</div>`;
// Exports
export default code;